/* ===== Michelada Labs — Dark Lab interactions ===== */
(function () {
  'use strict';

  var supportsHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Card / stage tilt (desktop only — never binds on touch) ---------- */
  function initTilt() {
    if (!supportsHover || prefersReducedMotion) return;

    document.querySelectorAll('[data-dl-tilt]').forEach(function (stage) {
      var inner = stage.querySelector('[data-dl-tilt-inner]');
      if (!inner) return;
      var strength = parseFloat(stage.getAttribute('data-dl-tilt-strength')) || 10;

      stage.addEventListener('mousemove', function (e) {
        var rect = stage.getBoundingClientRect();
        var px = (e.clientX - rect.left) / rect.width;
        var py = (e.clientY - rect.top) / rect.height;
        var rx = (0.5 - py) * strength;
        var ry = (px - 0.5) * strength;
        inner.style.transform = 'rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg)';
        stage.style.setProperty('--dl-mx', (px * 100).toFixed(1) + '%');
        stage.style.setProperty('--dl-my', (py * 100).toFixed(1) + '%');
      });

      stage.addEventListener('mouseleave', function () {
        inner.style.transform = 'rotateX(0deg) rotateY(0deg)';
      });
    });
  }

  /* ---------- Whole-card click-through to product page ----------
     Real <a> tags on the thumbnail/title already provide a no-JS
     fallback and correct touch behavior. This just extends the
     clickable area to the rest of the card, while ignoring clicks
     that originate from the add-to-cart form/button so that keeps
     working normally. */
  function initCardLinks() {
    document.querySelectorAll('[data-dl-card-link]').forEach(function (card) {
      var url = card.getAttribute('data-dl-card-link');
      if (!url) return;

      card.addEventListener('click', function (e) {
        if (e.target.closest('a, button, form, input, select, textarea')) return;
        window.location.href = url;
      });
    });
  }

  /* ---------- Hero 3D backdrop (Three.js) ---------- */
  function initHero() {
    var heroEl = document.querySelector('[data-dl-hero]');
    var canvas = document.querySelector('[data-dl-hero-canvas]');
    if (!heroEl || !canvas || typeof THREE === 'undefined' || prefersReducedMotion) return;

    var renderer = new THREE.WebGLRenderer({ canvas: canvas, alpha: true, antialias: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));

    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(50, 1, 0.1, 100);
    camera.position.z = 6;

    var geometry = new THREE.IcosahedronGeometry(2.1, 1);
    var material = new THREE.MeshBasicMaterial({
      color: 0xd4ff3f,
      wireframe: true,
      transparent: true,
      opacity: 0.35
    });
    var mesh = new THREE.Mesh(geometry, material);
    scene.add(mesh);

    var particlesGeo = new THREE.BufferGeometry();
    var count = 220;
    var positions = new Float32Array(count * 3);
    for (var i = 0; i < count; i++) {
      positions[i * 3] = (Math.random() - 0.5) * 12;
      positions[i * 3 + 1] = (Math.random() - 0.5) * 8;
      positions[i * 3 + 2] = (Math.random() - 0.5) * 6;
    }
    particlesGeo.setAttribute('position', new THREE.BufferAttribute(positions, 3));
    var particlesMat = new THREE.PointsMaterial({ color: 0xf0ece1, size: 0.02, transparent: true, opacity: 0.5 });
    var particles = new THREE.Points(particlesGeo, particlesMat);
    scene.add(particles);

    function resize() {
      var w = heroEl.clientWidth;
      var h = heroEl.clientHeight;
      if (!w || !h) return;
      renderer.setSize(w, h, false);
      camera.aspect = w / h;
      camera.updateProjectionMatrix();
    }
    resize();
    window.addEventListener('resize', resize);

    var pointerX = 0, pointerY = 0;
    if (supportsHover) {
      heroEl.addEventListener('mousemove', function (e) {
        var rect = heroEl.getBoundingClientRect();
        pointerX = ((e.clientX - rect.left) / rect.width - 0.5) * 2;
        pointerY = ((e.clientY - rect.top) / rect.height - 0.5) * 2;
      });
    }

    var visible = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
      }).observe(heroEl);
    }

    function animate() {
      requestAnimationFrame(animate);
      if (!visible) return;
      mesh.rotation.y += 0.0015;
      mesh.rotation.x += 0.0006;
      camera.position.x += (pointerX * 0.6 - camera.position.x) * 0.04;
      camera.position.y += (-pointerY * 0.4 - camera.position.y) * 0.04;
      camera.lookAt(scene.position);
      particles.rotation.y += 0.0004;
      renderer.render(scene, camera);
    }
    animate();
  }

  function init() {
    initTilt();
    initCardLinks();
    initHero();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
